/**
 *-------------------------------------------
 * create userInfoActions actions in redux
 *-------------------------------------------
 */

import * as userInfoActions from '../constants/userInfo'

export const getUser = () => {
    return {
        type: userInfoActions.GET_USERINFO
    }
}

export const updateUser = (user) => {
    return {
        type: userInfoActions.UPDATE_USERINFO,
        user
    }
}
